import { Palette } from "@mui/material";
import { FACE_NAMES } from "./constants";
import { ExperienceRating } from "./types";

export const getIconColor = (isSelected: boolean, iconName: ExperienceRating, palette: Palette) => {
  if (!isSelected) return palette.blue[500]

  switch(iconName) {
    case 'pouting': {
      return palette.red[500]
    }
    case 'frown': {
      return palette.orange[600]
    }
    case 'meh': {
      return palette.amber[700]
    }
    case 'smile': {
      return palette.lime[600]
    }
    case 'grin': {
      return palette.green[500]
    }
    default: return palette.blue[500]
  }
}

export const getTabIndex = (
  index: number,
  faceType: ExperienceRating,
  focusedIndex: number,
  selectedRate: ExperienceRating,
  disabled: boolean
): number => {
  if (disabled) return -1
  if (focusedIndex >= 0) {
    return focusedIndex === index ? 0 : -1
  }
  if (selectedRate) {
    return selectedRate === faceType ? 0 : -1
  }
  return index === 0 ? 0 : -1
}

export const getNextIndex = (
  key: string,
  currentIndex: number
): number | null => {
  if (key === "ArrowRight" || key === "ArrowDown") {
    return (currentIndex + 1) % FACE_NAMES.length
  }
  if (key === "ArrowLeft" || key === "ArrowUp") {
    return (currentIndex - 1 + FACE_NAMES.length) % FACE_NAMES.length
  }
  return null
}